import type { FaireProductEntity } from "../../entity_types/product";

export const p_41i9adts: FaireProductEntity = {
  token: "p_41i9adts",
  type: "product",
  name: "Body Wash 16 oz | Non-toxic, Real Soap",
  brandToken: "b_1kcui4ks",
  brandName: "MamaSuds | Non-toxic Household Cleaners + Real Soap",
  imageUrl:
    "https://cdn.faire.com/fastly/3445285665992d79302a3715dfd2366a6b385765be61fca5e2e8d24796bf12fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ad151d7676b5475f76413d9ad3d32c412fdc6df9bf0f3e572f2352ea1b8e2de.jpeg",
    "https://cdn.faire.com/fastly/a493531c385b8c7811e7f6b2df4be067cf096516f4c8c16141256e1e35782c0d.jpeg",
    "https://cdn.faire.com/fastly/da034472bc61e2f2f906dcd5df7e2a6d2347d6e6e364f6ec0569560ff4cb8da5.png",
    "https://cdn.faire.com/fastly/2c956c12b6cf0afa677756b8e6d67ccacde7251eac579716cf1a8d88d0908256.png",
    "https://cdn.faire.com/fastly/debf015669a623d1bb79126c4d881b1e354e25b8445df6c7ff3905d64e73d006.png",
    "https://cdn.faire.com/fastly/7a50d5e5234ad12f6ef7f5435ca820d931d59df40c548eca17a5a7ed6583ab14.png",
    "https://cdn.faire.com/fastly/6c7924d0eac602cd3ce2af1249d3f710ceec1ae25f605c49101a9b6bec0ac4e0.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "\n16  fluid  ounces  \n•INGREDIENTS:  distilled  water,  saponified olive  oil (potassium olivate)\n•Scents:  unscented,  lavender, or  lemon\n• Vegan and Cruelty-free (certified PETA and Leaping Bunny)\n•Biodegrable, safe for septic and gray water systems",
  tags: [],
  msrpDollars: 12.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:52.923Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
